export const SET_SECURE_MODE = 'SET_SECURE_MODE';

export default () => ({
  type: SET_SECURE_MODE,
});
